import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { categoryApi } from "../../../api/categoryApi";
import { genTaskApi } from "../../../api/genTaskApi";
import MultipleSearchSelectApi from "../../../components/common/MultipleSearchSelectApi";
import { TaskType } from "../../../Constants/Status";
import "./ExamByCategory.css";

export default function ExamByCategory() {
  const navigate = useNavigate();
  const [filtersSelected, setFiltersSelected] = useState([]);
  const [numberSetQuestion, setNumberOfQuestion] = useState(-1);
  const [taskName, setTaskName] = useState("");
  const [tasks, setTasks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);

  useEffect(() => {
    fetchTasks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchCategoriesTable = async (search) => {
    try {
      const params = {
        pageNumber: 1,
        pageSize: 10,
        filters: {},
        isSortDesc: false,
        sortKey: "createdAt",
        seachKey: search,
      };
      const res = await categoryApi.getTable(params);
      const items = res?.data?.items || [];
      return items.map((x) => ({ value: x.id, label: x.name }));
    } catch {
      return [];
    }
  };

  const fetchTasks = async () => {
    setIsLoading(true);
    try {
      const params = {
        pageNumber: 1,
        pageSize: 12,
        filters: {},
        isSortDesc: true,
        sortKey: "createdAt",
        seachKey: "",
      };
      const res = await genTaskApi.table(params);
      if (res?.success) {
        setTasks(res?.data?.items || []);
      } else {
        setTasks([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleClickCardTask = (item) => {
    navigate("/exam/flashcard", {
      state: {
        taskId: item.taskId,
        name: item.name,
        type: TaskType.ByCategory,
      },
    });
  };

  const handleOpenAttemptHistory = (item) => {
    navigate(`/exam/history/${item.taskId}`, {
      state: {
        title: item.title,
      },
    });
  };

  const handleGenerateTask = async () => {
    const questionCount = Number(numberSetQuestion);
    const param = {
      categoryIds: (filtersSelected || []).map((x) => x.value),
      numberofQuestion: Number.isNaN(questionCount) ? -1 : questionCount,
      taskType: TaskType.ByCategory,
      Name: taskName,
    };
    setIsGenerating(true);
    try {
      const rs = await genTaskApi.generate(param);
      if (rs?.success) {
        setNumberOfQuestion(-1);
        setFiltersSelected([]);
        setTaskName("");
        await fetchTasks();
      }
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="container py-4 exam-by-category">
      <section className="exam-hero mb-4">
        <div>
          <h2 className="exam-title mb-1">Exam Builder</h2>
          <p className="exam-subtitle mb-0">
            Tạo đề nhanh theo category. Xem lịch sử làm bài theo từng task bằng icon history.
          </p>
        </div>
      </section>

      <div className="row g-4">
        <div className="col-12">
          <div className="exam-card p-4">
            <h5 className="mb-3">Generate New Task</h5>

            <label className="form-label fw-semibold">Choose Categories</label>
            <MultipleSearchSelectApi
              fetchApi={fetchCategoriesTable}
              value={filtersSelected}
              onChange={(val) => setFiltersSelected(val)}
              onOk={async (selected) => setFiltersSelected(selected || [])}
            />

            <div className="row g-3 mt-1">
              <div className="col-md-6">
                <label className="form-label fw-semibold">Number of Questions</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="-1 means all"
                  value={numberSetQuestion}
                  onChange={(e) => setNumberOfQuestion(e.target.value)}
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-semibold">Task Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Set task name"
                  value={taskName}
                  onChange={(e) => setTaskName(e.target.value)}
                />
              </div>
            </div>

            <button
              className="btn exam-generate-btn mt-3"
              onClick={handleGenerateTask}
              disabled={isGenerating || filtersSelected.length === 0}
            >
              {isGenerating ? "Generating..." : "Generate Task"}
            </button>
          </div>
        </div>
      </div>

      <section className="mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">Task Library</h5>
          <button className="btn btn-sm btn-outline-secondary" onClick={fetchTasks}>
            Refresh
          </button>
        </div>

        {isLoading ? (
          <div className="text-muted">Loading tasks...</div>
        ) : (
          <div className="row g-3">
            {tasks.map((item) => (
              <div key={item.taskId} className="col-md-6 col-xl-4">
                <div className="task-card h-100">
                  <div className="d-flex justify-content-between align-items-start gap-2">
                    <div className="task-title">{item.title}</div>
                    <button
                      className="btn btn-sm btn-outline-dark task-history-icon"
                      title="View task attempt history"
                      onClick={() => handleOpenAttemptHistory(item)}
                    >
                      <i className="bi bi-clock-history"></i>
                    </button>
                  </div>

                  <div className="task-time mb-3">
                    {new Date(item.createTime).toLocaleString("vi-VN")}
                  </div>

                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => handleClickCardTask(item)}
                    >
                      <i className="bi bi-play-fill me-1"></i>
                      Start
                    </button>
                  </div>
                </div>
              </div>
            ))}

            {!tasks.length && <div className="text-muted">No tasks found.</div>}
          </div>
        )}
      </section>
    </div>
  );
}
